import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BulkUploadService } from "../services/bulk-upload.service";
import { HttpService } from "app/ppm-app/shared/services/http.service";

@Component({
  selector: "app2-bulk-upload-onboarding-member",
  templateUrl: "./bulk-upload-onboarding-member.component.html",
  styleUrls: ["./bulk-upload-onboarding-member.component.css"],
})
export class BulkUploadOnboardingMemberComponent implements OnInit {
  bulkUploadForm = new FormGroup({
    uploadForm: new FormControl(null),
  });

  isButtonDisabled: boolean = true;
  isErrorMessage: boolean = false;
  isButtonRole: string;
  isLoading: boolean = false;
  isServerError: boolean = false;
  isUploadSuccess: boolean = false;

  constructor(private bulkUploadService: BulkUploadService) {
    const account = localStorage.getItem("account");
    const parsedAccount = JSON.parse(account);
    this.isButtonRole = parsedAccount.authorities[0];
  }

  ngOnInit(): void {}

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (
        file.type ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.size < 100000
      ) {
        this.bulkUploadForm.get("uploadForm").setValue(file);
        this.isButtonDisabled = false;
        this.isErrorMessage = false;
      } else {
        this.isErrorMessage = true;
        this.isButtonDisabled = true;
      }
    }
  }

  onSubmit() {
    this.isLoading = true;

    const formData = new FormData();
    formData.append("file", this.bulkUploadForm.get("uploadForm").value);

    this.bulkUploadService.generateXclient().subscribe((resp: any) => {
      if (resp.responseCode === 200 && resp.statusCode == "AU441") {
        this.bulkUploadService
          .uploadExcelForm(formData, resp.replyMessageList[0].token)
          .subscribe((resp: any) => {
            if (resp.responseCode === 200) {
              this.isLoading = false;
              this.isUploadSuccess = true;
            } else {
              this.isLoading = false;
              this.isServerError = true;
            }
          });
      }
    });
  }
}
